module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                    Mailing\n                    →\n                    "), (_vm.$route.name.indexOf('request') !== -1) ? _c('span', [_vm._v("\n                        Catalog Requests\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.$route.name.indexOf('subscription') !== -1) ? _c('span', [_vm._v("\n                        Newsletter Subscriptions\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.$route.name.indexOf('email-list') !== -1) ? _c('span', [_vm._v("\n                        Email List\n                    ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'requests'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Catalog Requests")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'subscriptions'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Newsletter Subscriptions")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'email-list'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Email List")])])], 1)]), _vm._v(" "), _c('div', [_c('transition', {
    attrs: {
      "mode": "out-in",
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eda8c610"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/Mailing.vue
// module id = 584
// module chunks = 0